import { BasePayloadMapper } from '@ps/utils';

import { LoginPayloadDto } from '../dtos/auth.dto';
import { AuthCredentials } from '../../models/auth.model';

export class AuthPayloadMapper extends BasePayloadMapper<
  AuthCredentials,
  LoginPayloadDto
> {
  public toPayload(data: AuthCredentials): LoginPayloadDto {
    return {
      email: data.email,
      password: data.password,
      captcha: data.captcha,
      rememberMe: data.rememberMe,
    };
  }
}
